// menu.js
import { trapFocus } from "../helpers/index.js";

const hamburger = document.getElementById('hamburger');
const nav = document.getElementById('nav');

// Function to toggle the menu visibility
function toggleMenu() {
  const isOpen = hamburger.getAttribute('aria-expanded') === 'true' || false;

  // Toggle aria-expanded attribute
  hamburger.setAttribute('aria-expanded', String(!isOpen));

  // Toggle nav visibility using a class
  if (!isOpen) {
    openMenu();
  } else {
    nav.classList.remove('open');
  }
}

// open menu
function openMenu() {
  nav.classList.add('open');
  trapFocus(nav);
}

// close menu
function closeMenu() {
  nav.classList.remove('open');
  hamburger.setAttribute('aria-expanded', 'false');
}

// Toggle the menu on click
hamburger.addEventListener('click', toggleMenu);

// Hide nav on keyup Escape
nav.addEventListener('keyup', (e) => {
  if (e.code === 'Escape') {
    closeMenu()
  }
});

// Close the menu if a nav link is clicked
nav.addEventListener('click', (e) => {
  if (e.target.tagName === 'A') {
    closeMenu()
  }
});

document.addEventListener('click', (e) => {
  const isHamburgerClick = e.target === hamburger || hamburger.contains(e.target);
  const isNavClick = e.target.closest('#nav') !== null;

  if (!isHamburgerClick && !isNavClick) {
    closeMenu()
  }
});

// Close the navigation on window resize
window.addEventListener('resize', () => {
  closeMenu()
});
